'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setEndpointsRootDomain = exports.commerceConfiguration = exports.commerceSource = exports.commerce = exports.britannica = exports.userLeads = exports.workflow = exports.embed = exports.emailSupport = exports.testDrive = exports.crawlRunData = exports.extractorService = exports.urlDiscovery = exports.encryptedObject = exports.runReport = exports.findPortal = exports.sitemapUrlGroup = exports.sitemapDomain = exports.portal = exports.dataSuggest = exports.reportConfiguration = exports.reportRun = exports.report = exports.emailVerification = exports.suggest = exports.encrypt = exports.keyValueStore = exports.listProducer = exports.firebaseAuth = exports.packages = exports.user = exports.webcache = exports.schedule = exports.runtimeConfiguration = exports.run = exports.getData = exports.extractor = exports.crawlRunDiffConfig = exports.crawlRunDiff = exports.crawlRun = exports.billing = exports.auth = exports.BaseApi = exports.ResponseError = exports.ParameterError = undefined;
var _ParameterError = require('./ParameterError');
Object.defineProperty(exports, 'ParameterError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ParameterError).default;
  }
});
var _ResponseError = require('./ResponseError');
Object.defineProperty(exports, 'ResponseError', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ResponseError).default;
  }
});
var _BaseApi = require('./BaseApi');
Object.defineProperty(exports, 'BaseApi', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BaseApi).default;
  }
});
require('proxy-polyfill');
var _frontendUtils = require('@import/frontend-utils');
var _AuthApi = require('./apis/AuthApi');
var _AuthApi2 = _interopRequireDefault(_AuthApi);
var _BillingApi = require('./apis/BillingApi');
var _BillingApi2 = _interopRequireDefault(_BillingApi);
var _CrawlRunApi = require('./apis/CrawlRunApi');
var _CrawlRunApi2 = _interopRequireDefault(_CrawlRunApi);
var _CrawlRunDiffApi = require('./apis/CrawlRunDiffApi');
var _CrawlRunDiffApi2 = _interopRequireDefault(_CrawlRunDiffApi);
var _CrawlRunDiffConfigApi = require('./apis/CrawlRunDiffConfigApi');
var _CrawlRunDiffConfigApi2 = _interopRequireDefault(_CrawlRunDiffConfigApi);
var _ExtractorApi = require('./apis/ExtractorApi');
var _ExtractorApi2 = _interopRequireDefault(_ExtractorApi);
var _GetDataApi = require('./apis/GetDataApi');
var _GetDataApi2 = _interopRequireDefault(_GetDataApi);
var _ListProducerApi = require('./apis/ListProducerApi');
var _ListProducerApi2 = _interopRequireDefault(_ListProducerApi);
var _RunApi = require('./apis/RunApi');
var _RunApi2 = _interopRequireDefault(_RunApi);
var _RuntimeConfigurationApi = require('./apis/RuntimeConfigurationApi');
var _RuntimeConfigurationApi2 = _interopRequireDefault(_RuntimeConfigurationApi);
var _ScheduleApi = require('./apis/ScheduleApi');
var _ScheduleApi2 = _interopRequireDefault(_ScheduleApi);
var _WebcacheApi = require('./apis/WebcacheApi');
var _WebcacheApi2 = _interopRequireDefault(_WebcacheApi);
var _UserApi = require('./apis/UserApi');
var _UserApi2 = _interopRequireDefault(_UserApi);
var _PackageApi = require('./apis/PackageApi');
var _PackageApi2 = _interopRequireDefault(_PackageApi);
var _FirebaseAuthApi = require('./apis/FirebaseAuthApi');
var _FirebaseAuthApi2 = _interopRequireDefault(_FirebaseAuthApi);
var _KeyValueStoreApi = require('./apis/KeyValueStoreApi');
var _KeyValueStoreApi2 = _interopRequireDefault(_KeyValueStoreApi);
var _EncryptApi = require('./apis/EncryptApi');
var _EncryptApi2 = _interopRequireDefault(_EncryptApi);
var _SuggestApi = require('./apis/SuggestApi');
var _SuggestApi2 = _interopRequireDefault(_SuggestApi);
var _EmailVerificationApi = require('./apis/EmailVerificationApi');
var _EmailVerificationApi2 = _interopRequireDefault(_EmailVerificationApi);
var _ReportApi = require('./apis/ReportApi');
var _ReportApi2 = _interopRequireDefault(_ReportApi);
var _ReportRunApi = require('./apis/ReportRunApi');
var _ReportRunApi2 = _interopRequireDefault(_ReportRunApi);
var _ReportConfigurationApi = require('./apis/ReportConfigurationApi');
var _ReportConfigurationApi2 = _interopRequireDefault(_ReportConfigurationApi);
var _DataSuggestApi = require('./apis/DataSuggestApi');
var _DataSuggestApi2 = _interopRequireDefault(_DataSuggestApi);
var _PortalApi = require('./apis/PortalApi');
var _PortalApi2 = _interopRequireDefault(_PortalApi);
var _SitemapDomainApi = require('./apis/SitemapDomainApi');
var _SitemapDomainApi2 = _interopRequireDefault(_SitemapDomainApi);
var _SitemapUrlGroupApi = require('./apis/SitemapUrlGroupApi');
var _SitemapUrlGroupApi2 = _interopRequireDefault(_SitemapUrlGroupApi);
var _FindPortalApi = require('./apis/FindPortalApi');
var _FindPortalApi2 = _interopRequireDefault(_FindPortalApi);
var _RunReportApi = require('./apis/RunReportApi');
var _RunReportApi2 = _interopRequireDefault(_RunReportApi);
var _EncryptedObjectApi = require('./apis/EncryptedObjectApi');
var _EncryptedObjectApi2 = _interopRequireDefault(_EncryptedObjectApi);
var _UrlDiscoveryApi = require('./apis/UrlDiscoveryApi');
var _UrlDiscoveryApi2 = _interopRequireDefault(_UrlDiscoveryApi);
var _ExtractorServiceApi = require('./apis/ExtractorServiceApi');
var _ExtractorServiceApi2 = _interopRequireDefault(_ExtractorServiceApi);
var _CrawlRunData = require('./apis/CrawlRunData');
var _CrawlRunData2 = _interopRequireDefault(_CrawlRunData);
var _TestDriveApi = require('./apis/TestDriveApi');
var _TestDriveApi2 = _interopRequireDefault(_TestDriveApi);
var _EmailSupportApi = require('./apis/EmailSupportApi');
var _EmailSupportApi2 = _interopRequireDefault(_EmailSupportApi);
var _EmbedApi = require('./apis/EmbedApi');
var _EmbedApi2 = _interopRequireDefault(_EmbedApi);
var _WorkflowApi = require('./apis/WorkflowApi');
var _WorkflowApi2 = _interopRequireDefault(_WorkflowApi);
var _UserLeadsApi = require('./apis/UserLeadsApi');
var _UserLeadsApi2 = _interopRequireDefault(_UserLeadsApi);
var _BritannicaApi = require('./apis/BritannicaApi');
var _BritannicaApi2 = _interopRequireDefault(_BritannicaApi);
var _CommerceApi = require('./apis/CommerceApi');
var _CommerceApi2 = _interopRequireDefault(_CommerceApi);
var _CommerceSourceApi = require('./apis/CommerceSourceApi');
var _CommerceSourceApi2 = _interopRequireDefault(_CommerceSourceApi);
var _CommerceConfigurationApi = require('./apis/CommerceConfigurationApi');
var _CommerceConfigurationApi2 = _interopRequireDefault(_CommerceConfigurationApi);
var _proxyClassUtil = require('./proxyClassUtil');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var auth = exports.auth = new _AuthApi2.default();
var billing = exports.billing = new _BillingApi2.default();
var crawlRun = exports.crawlRun = new _CrawlRunApi2.default();
var crawlRunDiff = exports.crawlRunDiff = new _CrawlRunDiffApi2.default();
var crawlRunDiffConfig = exports.crawlRunDiffConfig = new _CrawlRunDiffConfigApi2.default();
var extractor = exports.extractor = (0, _proxyClassUtil.makeObjectStoreProxy)(new _ExtractorApi2.default());
var getData = exports.getData = new _GetDataApi2.default();
var run = exports.run = new _RunApi2.default();
var runtimeConfiguration = exports.runtimeConfiguration = new _RuntimeConfigurationApi2.default();
var schedule = exports.schedule = new _ScheduleApi2.default();
var webcache = exports.webcache = new _WebcacheApi2.default();
var user = exports.user = (0, _proxyClassUtil.makeObjectStoreProxy)(new _UserApi2.default());
var packages = exports.packages = new _PackageApi2.default();
var firebaseAuth = exports.firebaseAuth = new _FirebaseAuthApi2.default();
var listProducer = exports.listProducer = new _ListProducerApi2.default();
var keyValueStore = exports.keyValueStore = new _KeyValueStoreApi2.default();
var encrypt = exports.encrypt = new _EncryptApi2.default();
var suggest = exports.suggest = new _SuggestApi2.default();
var emailVerification = exports.emailVerification = new _EmailVerificationApi2.default();
var report = exports.report = new _ReportApi2.default();
var reportRun = exports.reportRun = (0, _proxyClassUtil.makeObjectStoreProxy)(new _ReportRunApi2.default());
var reportConfiguration = exports.reportConfiguration = new _ReportConfigurationApi2.default();
var dataSuggest = exports.dataSuggest = new _DataSuggestApi2.default();
var portal = exports.portal = new _PortalApi2.default();
var sitemapDomain = exports.sitemapDomain = new _SitemapDomainApi2.default();
var sitemapUrlGroup = exports.sitemapUrlGroup = new _SitemapUrlGroupApi2.default();
var findPortal = exports.findPortal = new _FindPortalApi2.default();
var runReport = exports.runReport = new _RunReportApi2.default();
var encryptedObject = exports.encryptedObject = new _EncryptedObjectApi2.default();
var urlDiscovery = exports.urlDiscovery = new _UrlDiscoveryApi2.default();
var extractorService = exports.extractorService = new _ExtractorServiceApi2.default();
var crawlRunData = exports.crawlRunData = new _CrawlRunData2.default();
var testDrive = exports.testDrive = new _TestDriveApi2.default();
var emailSupport = exports.emailSupport = new _EmailSupportApi2.default();
var embed = exports.embed = new _EmbedApi2.default();
var workflow = exports.workflow = new _WorkflowApi2.default();
var userLeads = exports.userLeads = new _UserLeadsApi2.default();
var britannica = exports.britannica = new _BritannicaApi2.default();
var commerce = exports.commerce = new _CommerceApi2.default();
var commerceSource = exports.commerceSource = new _CommerceSourceApi2.default();
var commerceConfiguration = exports.commerceConfiguration = new _CommerceConfigurationApi2.default();
var setEndpointsRootDomain = exports.setEndpointsRootDomain = function setEndpointsRootDomain(endpointsRootDomain) {
  return _frontendUtils.endpoints.endpointsRootDomain = endpointsRootDomain;
};